import Layout from "@/components/Layout";
import Ornament from "@/components/Ornament";

export default function MenuPage() {
  return (
    <Layout>
      <section className="border-b border-ink">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pt-16 md:pt-24 pb-12 md:pb-20 text-center">
          <div className="overline mb-6">Carta della Cucina</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">
            Il nostro <em className="text-wine">menu</em>
          </h1>
        </div>
      </section>

      <section className="section">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Ornament />
          <div className="overline mb-6">Avviso</div>
          <h2 className="font-serif text-4xl md:text-6xl leading-tight">
            Pagina <em className="text-wine">in aggiornamento</em>
          </h2>
          <p className="text-ink-mid mt-8 leading-relaxed text-lg max-w-xl mx-auto">
            Stiamo rinnovando la nostra carta. Torna a trovarci presto — nel
            frattempo, per qualunque informazione su piatti, vini e specialità,
            chiamaci o passa in sede.
          </p>
          <Ornament />
        </div>
      </section>
    </Layout>
  );
}
